module.exports = __webpack_public_path__ + "img/large.e355de1c.svg";